import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type { UpdateStopInfoRequest, UpdateStopInfoResponse } from '../type';
import { verifyStopInfoFn } from './verify-stop-info-fn';
import { apiRoutes } from '@/api/api-routes';

export const useVerifyStopInfo = (
  orderId: string,
  opts?: UseMutationOptions<
    UpdateStopInfoResponse,
    DefaultQueryError,
    UpdateStopInfoRequest
  >
) =>
  useMutation<UpdateStopInfoResponse, DefaultQueryError, UpdateStopInfoRequest>(
    {
      mutationKey: [apiRoutes.order.stopInformation, 'verify'],
      mutationFn: (body: UpdateStopInfoRequest) =>
        verifyStopInfoFn(orderId, body),
      ...opts,
    }
  );
